<div [hidden]="!isLoading" class="loading" >
    <div class="loader">
      <div class="dot-pulse"></div>
    </div>
  </div>
  